import React from "react";
import ReusableUserFilter from "../../directorate/ui/ReusableUserFilter";

export default function PastorUserFilter() {
  return <ReusableUserFilter />;
}
